<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          GUIDELINE DOCUMENT
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9 class="pl-1">
            {{
              id
                ? type + ' Guideline Document'
                : 'Create New Guideline Document'
            }}
          </v-flex>
          <v-flex xs3 class="text-right" v-if="isEdit || isDetail">
            <v-icon @click="getDetail" title="refresh">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-layout row wrap>
              <v-flex xs12 class="pa-0">
                <v-flex xs12>
                  <ValidationProvider
                    name="Title"
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <label class="darkblue--text">Title</label>
                    <v-text-field
                      id="title"
                      single-line
                      outlined
                      placeholder="Title Document"
                      dense
                      v-model="items.title"
                      required
                      :error-messages="errors"
                      :success="valid"
                      :disabled="isDetail"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    name="Version"
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <label class="darkblue--text ">Version</label>
                    <v-text-field
                      id="version"
                      single-line
                      outlined
                      placeholder="Version Document"
                      dense
                      v-model="items.version"
                      required
                      :error-messages="errors"
                      :success="valid"
                      :disabled="isDetail"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    name="Description"
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <label class="darkblue--text">Description</label>
                    <v-textarea
                      id="description"
                      single-line
                      outlined
                      placeholder="Description"
                      v-model="items.description"
                      required
                      :error-messages="errors"
                      :success="valid"
                      :disabled="isDetail"
                    ></v-textarea>
                  </ValidationProvider>

                  <v-row class="" v-if="isDetail">
                    <v-flex xs4>
                      <label>Document in English</label>
                    </v-flex>
                    <v-flex xs7 class="pt-3 px-0">
                      <label>{{ ':' + items.document_en }} </label>
                    </v-flex>
                    <v-flex xs1 class="pt-1">
                      <v-btn
                        icon
                        id="btn-download"
                        @click="downloadFile(items.document_en)"
                      >
                        <v-icon
                          color="primary"
                          style="font-size: 20px !important;"
                          >cloud_download</v-icon
                        >
                      </v-btn>
                    </v-flex>
                    <v-flex xs4>
                      <label>Document in Bahasa</label>
                    </v-flex>
                    <v-flex xs7 class="pt-3 px-0">
                      <label>{{ ':' + items.document_id }} </label>
                    </v-flex>
                    <v-flex xs1 class="pt-1">
                      <v-btn
                        icon
                        id="btn-download"
                        @click="downloadFile(items.document_id)"
                      >
                        <v-icon
                          color="primary"
                          style="font-size: 20px !important;"
                          >cloud_download</v-icon
                        >
                      </v-btn>
                    </v-flex>
                  </v-row>
                  <v-row class="" v-else>
                    <v-flex xs12 v-if="isEdit">
                      <v-row>
                        <v-flex xs4>
                          <label>Document in English</label>
                        </v-flex>
                        <v-flex xs7 class="pt-3 px-0">
                          <label>{{ ':' + docsEn }} </label>
                        </v-flex>
                        <v-flex xs1 class="pt-1">
                          <v-btn
                            icon
                            id="btn-download"
                            @click="downloadFile(docsEn)"
                          >
                            <v-icon
                              color="primary"
                              style="font-size: 20px !important;"
                              >cloud_download</v-icon
                            >
                          </v-btn>
                        </v-flex>
                        <v-flex xs4>
                          <label>Document in Bahasa</label>
                        </v-flex>
                        <v-flex xs7 class="pt-3 px-0">
                          <label>{{ ':' + docsIn }} </label>
                        </v-flex>
                        <v-flex xs1 class="pt-1">
                          <v-btn
                            icon
                            id="btn-download"
                            @click="downloadFile(docsIn)"
                          >
                            <v-icon
                              color="primary"
                              style="font-size: 20px !important;"
                              >cloud_download</v-icon
                            >
                          </v-btn>
                        </v-flex>
                      </v-row>
                    </v-flex>
                    <v-flex xs6 class="pt-0">
                      <uploader-vue
                        @afterComplete="uploadCompleteEnglish"
                        ref="docsenComponent"
                        title="English Version"
                        type=".docs"
                        @fileRemoved="cancelUploadEn"
                      ></uploader-vue>
                    </v-flex>
                    <v-flex xs6 class="pt-0">
                      <uploader-vue
                        @afterComplete="uploadCompleteIndo"
                        ref="docsidComponent"
                        title="Indo Version"
                        type=".docs"
                        @fileRemoved="cancelUploadId"
                      ></uploader-vue>
                    </v-flex>
                  </v-row>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right px-0">
              <v-spacer></v-spacer>
              <v-flex xs2 right>
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'docs' }"
                >
                  Back
                </v-btn>
              </v-flex>
              <v-flex xs2 right v-if="!isDetail" class="ml-4">
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  @click="save()"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';
import UploaderVue from '../../../components/uploader';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'progress-dialog': ProgressDialog,
    'uploader-vue': UploaderVue
  },
  props: ['id', 'type'],
  data() {
    return {
      items: {
        version: '',
        description: '',
        document_en: {},
        document_id: {}
      },
      docsEn: '',
      docsIn: '',
      isEdit: false,
      isDetail: false,
      loading: true,
      progressDialogLoading: true,
      search: '',
      baseUrl: process.env.VUE_APP_BASE_URL,
      breadcrumbs: [
        {
          text: 'Content Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Guideline Document List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: this.id
            ? this.type + ' Guideline Document'
            : 'Create New Guideline Document',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ]
    };
  },
  mounted() {
    if (this.id) {
      if (this.type === 'Detail') {
        this.isDetail = true;
        this.getDetail();
      } else if (this.type === 'Edit') {
        this.isEdit = true;
        this.getDetail();
      }
    } else {
      setTimeout(() => {
        this.progressDialogLoading = false;
        this.loading = false;
      }, 800);
    }
  },
  methods: {
    uploadCompleteEnglish(obj) {
      console.log(obj);
      var fileType = obj.file.name.split('.').pop();
      var fileTypes = ['docx', 'pdf'];
      if (fileTypes.includes(fileType)) {
        this.items.document_en = obj;
      } else {
        Swal.fire('Failed!', 'Format file must be .docs or .pdf', 'error');
        this.$refs.docsenComponent.fileRemoved();
      }
    },
    uploadCompleteIndo(obj) {
      console.log(obj);
      var fileTypein = obj.file.name.split('.').pop();
      var fileTypesin = ['docx', 'pdf'];
      if (fileTypesin.includes(fileTypein)) {
        this.items.document_id = obj;
      } else {
        Swal.fire('Failed!', 'Format file must be .docs or .pdf', 'error');
        this.$refs.docsidComponent.fileRemoved();
      }
    },
    async getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      await this.$store
        .dispatch('docs/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data.result;
            if (this.isEdit) {
              this.docsEn = data.data.result.document_en;
              this.docsIn = data.data.result.document_id;
              this.items.document_en = '';
              this.items.document_id = '';
            }
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async clear() {
      this.items = {
        name: '',
        entity_id: null,
        house_id: null
      };
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        if (
          !this.isEdit &&
          (Object.keys(this.items.document_en).length === 0 ||
            Object.keys(this.items.document_id).length === 0)
        ) {
          Swal.fire(
            'Failed!',
            'You have to upload both English and Indo version documents.',
            'error'
          );
        } else {
          this.saveConfirm();
        }
      }
    },
    saveConfirm() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to save these documents?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel it!'
      }).then(result => {
        if (result.value) {
          this.saveGuideline();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your document data has been canceled to save',
            'error'
          );
        }
      });
    },
    saveGuideline() {
      this.progressDialogLoading = true;
      this.loading = true;
      if (this.id) {
        let formData = new FormData();
        formData.append('title', this.items.title);
        formData.append('version', this.items.version);
        formData.append('description', this.items.description);
        if (this.items.document_en !== '') {
          formData.append('document_en', this.items.document_en.file);
        }
        if (this.items.document_id !== '') {
          formData.append('document_id', this.items.document_id.file);
        }
        this.$store
          .dispatch('docs/update', { id: this.id, params: formData })
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.clear();
              this.$router.push({
                name: 'docs'
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        let formData = new FormData();
        formData.append('title', this.items.title);
        formData.append('version', this.items.version);
        formData.append('description', this.items.description);
        if (Object.keys(this.items.document_en).length !== 0) {
          formData.append('document_en', this.items.document_en.file);
        }
        if (Object.keys(this.items.document_id).length !== 0) {
          formData.append('document_id', this.items.document_id.file);
        }
        this.$store
          .dispatch('docs/create', formData)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.clear();
              this.$router.push({
                name: 'docs'
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      }
    },
    cancelUploadEn() {
      this.items.document_en = {};
      console.log(this.items.document_en);
    },
    cancelUploadId() {
      this.items.document_id = {};
      console.log(this.items.document_id);
    },
    downloadFile(val) {
      let file = encodeURIComponent(val);
      window.open(
        this.baseUrl +
          '/v1/download/file?name=' +
          file +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    }
  }
};
</script>
